module.exports = __webpack_public_path__ + "static/media/booking-calander.a569a6a6.svg";